<template>
  <v-list subheader>
    <v-item-group>
      <v-item v-show="!showWhenOptions" class="my-2">
        <CardItemsComponents
          :active="true"
          :disable="!$store.getters.checkoutValidation.deliveryInfo.status"
          @click="showWhenOptions = true"
        >
          <template v-slot:icon>
            <v-icon color="primary" v-text="serviceWhenSelected.icon" />
          </template>
          <template v-slot:body>
            <v-container fluid fill-height pa-0 ma-0>
              <v-row no-gutters>
                <v-col cols="12">
                  <span
                    class="list-text-title"
                    v-text="$t(serviceWhenSelected.name)"
                  />
                </v-col>
                <v-col cols="12" class="pt-1">
                  <span class="list-text-subtitle" v-text="whenMessage" />
                </v-col>
              </v-row>
            </v-container>
          </template>

          <template v-slot:actions>
            <v-icon
              v-if="showError"
              color="error"
              v-text="'mdi-alert-circle'"
            />
            <span
              v-else
              class="list-text-change"
              v-text="$t('general.change')"
            />
          </template>
        </CardItemsComponents>
      </v-item>
      <v-item v-show="showWhenOptions" class="list-item">
        <v-item-group
          v-model="serviceWhenSelected"
          mandatory
          style="width: 100%"
        >
          <v-expansion-panels focusable flat>
            <v-item
              v-for="(item, index) in whenOptions"
              :key="index"
              v-slot="{ active, toggle }"
              class="mb-1"
              :value="item"
            >
              <v-expansion-panel
                :v-ripple="!$store.getters.isLoading"
                readonly
                :class="{ active: active }"
                @click="item.id === 1 ? (showWhenOptions = true) : ''"
                @click.capture="toggle"
              >
                <v-expansion-panel-header hide-actions>
                  <v-container fluid pa-0 ma-0>
                    <v-row no-gutters justify="start" align-content="center">
                      <v-icon
                        :color="active ? 'primary' : ''"
                        v-text="
                          active
                            ? 'mdi-check-circle-outline'
                            : 'mdi-checkbox-blank-circle-outline'
                        "
                      />
                      <v-col class="ml-4">
                        <v-container fluid fill-height pa-0 ma-0>
                          <v-row no-gutters>
                            <v-col cols="12">
                              <span
                                class="list-text-title"
                                v-text="$t(item.name)"
                              />
                            </v-col>
                            <v-col cols="12" class="pt-1">
                              <span
                                class="list-text-subtitle"
                                v-text="
                                  active && !$store.getters.deliveryIsAsap
                                    ? whenMessage
                                    : $t(item.message, {
                                        etimateTime: etimateTime.asap,
                                      })
                                "
                              />
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-expansion-panel-header>
                <v-container v-if="item.id === 2" fluid>
                  <v-row
                    v-show="serviceWhenSelected.id === 2"
                    dense
                    justify="center"
                  >
                    <v-col cols="10">
                      <v-form
                        ref="form"
                        v-model="valid"
                        :disabled="$store.getters.isLoading"
                      >
                        <v-container fluid>
                          <v-row no-gutters justify="space-between">
                            <v-col cols="12" md="5">
                              <v-select
                                v-model="dateDelivery"
                                :items="datesAvilables"
                                item-text="name"
                                item-value="value"
                                prepend-icon="mdi-calendar-check"
                                :label="$t('inputs.day')"
                                :rules="[$rules.required]"
                                @change="onDateTimeChange"
                              />
                            </v-col>
                            <v-col cols="12" md="5">
                              <v-select
                                v-model="timeDelivery"
                                :items="timesAvilables"
                                item-text="name"
                                item-value="value"
                                :label="$t('inputs.time')"
                                prepend-icon="mdi-clock-check-outline"
                                :rules="[$rules.required]"
                                @change="onDateTimeChange"
                              />
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-form>
                    </v-col>
                    <v-col cols="10">
                      <ButtonSuccess
                        :color="
                          checkButtonType() === 'CHANGE' ? 'primary' : undefined
                        "
                        :title="getButtonTitle()"
                        :valid="valid"
                        @click="confirmScheduleTime"
                      />
                    </v-col>
                  </v-row>
                </v-container>
              </v-expansion-panel>
            </v-item>
          </v-expansion-panels>
        </v-item-group>
      </v-item>
    </v-item-group>
  </v-list>
</template>

<script>
/*
Actions:
  checkoutValidator:
    Mount
    Dates change
*/
import { WhenOptions } from "../../data/whenOptions";
import moment from "moment-timezone";
export default {
  name: "WhenSection",
  data: () => ({
    valid: false,
    showWhenOptions: true,
    showDatesTimes: false,
    serviceWhenSelected: "",
    whenOptions: [],
    datesAvilables: [],
    timesAvilables: [],
    dateDelivery: "",
    timeDelivery: "",
    etimateTime: [],
    savedDateDelivery: "", // Track the saved date
    savedTimeDelivery: "", // Track the saved time
    valuesChanged: false, // Track if values have changed from saved values
  }),
  computed: {
    showError: function () {
      return !this.$store.getters.checkoutValidation.deliveryWhen.status;
    },
    whenMessage: {
      get() {
        if (this.showError) {
          if (
            this.$store.getters.nonDeliverableReason &&
            this.$store.getters.nonDeliverableReason === "schedule-time"
          ) {
            return this.$t("checkout.AddressScheduleTime");
          }
          return this.$t("checkout.no_available");
        } else {
          if (
            this.$store.getters.estimatedTime &&
            this.$store.getters.deliveryIsAsap
          ) {
            return this.$t(this.serviceWhenSelected.message, {
              etimateTime: this.$store.getters.estimatedTime,
            });
          } else if (this.serviceWhenSelected.id === 1) {
            this.$store.dispatch(
              "delivery/setDeliveryTime",
              this.etimateTime.asap
            );
            return this.$t(this.serviceWhenSelected.message, {
              etimateTime: this.etimateTime.asap,
            });
          } else {
            if (this.dateDelivery) {
              let formattedDate = this.dateDelivery;
              const today = moment().startOf("day");
              const tomorrow = moment().add(1, "days").startOf("day");
              const deliveryDate = moment(
                this.dateDelivery,
                "YYYY-MM-DD"
              ).startOf("day");

              if (deliveryDate.isSame(today, "day")) {
                formattedDate = this.$t("checkout.today");
              } else if (deliveryDate.isSame(tomorrow, "day")) {
                formattedDate = this.$t("checkout.tomorrow");
              }

              // eslint-disable-next-line vue/no-side-effects-in-computed-properties
              this.savedDateDelivery = this.dateDelivery;
              // eslint-disable-next-line vue/no-side-effects-in-computed-properties
              this.savedTimeDelivery = this.timeDelivery;

              return this.$t(this.serviceWhenSelected.message, {
                date: formattedDate,
                time: this.timeDelivery
                  ? moment(this.timeDelivery, "HH:mm:ss").format("HH:mm")
                  : "",
              });
            } else {
              return this.$t("checkout.no_available");
            }
          }
        }
      },
      set(val) {
        return val;
      },
    },
    disableOption: function () {
      if (this.$store.getters.deliveryMethod === "delivery-service") {
        return !this.$checkoutValidator.deliveryInfo();
      } else {
        return false;
      }
    },
  },
  watch: {
    serviceWhenSelected: function () {
      if (this.$store.getters.deliveryMethod !== "pickup-service") {
        this.$store.dispatch("delivery/setDropoffDateTime", null);
      }
      if (this.serviceWhenSelected.id == 2) {
        this.loadDatesAvailables();
        this.$store.dispatch("delivery/setIsAsap", 0);
      } else {
        this.dateDelivery = "";
        this.timeDelivery = "";
        this.savedDateDelivery = "";
        this.savedTimeDelivery = "";
        this.valuesChanged = false;
        this.$store.dispatch("delivery/setIsAsap", 1);
      }
    },
    dateDelivery: function () {
      if (this.dateDelivery) {
        this.loadTimesAvailables();
      }
    },
    timeDelivery: function () {
      if (this.dateDelivery && this.timeDelivery) {
        this.$store.dispatch(
          "delivery/setDropoffDateTime",
          this.dateDelivery + " " + this.timeDelivery
        );
        // Use $nextTick to ensure store is updated before validation
        this.$nextTick(() => {
          this.$checkoutValidator.deliveryWhen();
        });
      } else {
        this.$store.dispatch("delivery/setDropoffDateTime", null);
        this.$checkoutValidator.deliveryWhen();
      }
    },
    "$store.getters.deliveryMethod": function () {
      this.datesAvilables = [];
      this.timesAvilables = [];
      this.dateDelivery = "";
      this.timeDelivery = "";
      this.savedDateDelivery = "";
      this.savedTimeDelivery = "";
      this.valuesChanged = false;
      this.showWhenOptions = true;
      this.loadEtimateTime();
    },
    showWhenOptions: function () {
      this.$emit("input", this.showWhenOptions);
    },
    "$store.getters.checkoutValidation.deliveryInfo.status": function () {
      if (this.$store.getters.checkoutValidation.deliveryInfo.status) {
        this.loadDatesAvailables();
      } else {
        this.showWhenOptions = true;
        this.dateDelivery = "";
        this.timeDelivery = "";
        this.savedDateDelivery = "";
        this.savedTimeDelivery = "";
        this.valuesChanged = false;
      }
    },
    "$i18n.locale": function () {
      // Re-run validation when language changes to update messages
      this.$checkoutValidator.deliveryWhen();
    },
  },
  mounted() {
    this.$checkoutValidator.deliveryWhen();
    if (this.$store.getters.deliveryMethod) {
      this.loadEtimateTime();
    }
  },
  methods: {
    // New method to check if values have changed from saved values
    onDateTimeChange: function () {
      if (this.savedDateDelivery && this.savedTimeDelivery) {
        this.valuesChanged =
          this.dateDelivery !== this.savedDateDelivery ||
          this.timeDelivery !== this.savedTimeDelivery;
      }
    },

    // New method to determine button title
    getButtonTitle: function () {
      const type = this.checkButtonType();
      if (type === "CONFIRM") {
        return this.$t("general.confirm");
      } else {
        return this.$t("general.change");
      }
    },
    checkButtonType: function () {
      if (!this.dateDelivery) {
        // No date selected yet, show "Confirm"
        return "CONFIRM";
      } else if (
        this.savedDateDelivery &&
        this.savedTimeDelivery &&
        !this.valuesChanged
      ) {
        // Values are saved and not changed - show "Change"
        return "CHANGE";
      } else if (this.valuesChanged) {
        // Values have been changed from saved values - show "Confirm"
        return "CONFIRM";
      } else if (
        this.savedDateDelivery === "" &&
        this.savedTimeDelivery === ""
      ) {
        // First time selecting values - show "Confirm"
        return "CONFIRM";
      } else {
        // Default to "Change" if already saved
        return "CHANGE";
      }
    },

    confirmScheduleTime: async function () {
      const address = this.$store.getters.guestAddress;
      if (address && this.$store.getters.deliveryMethod !== "pickup-service") {
        const { data } = await axios.get("/app/orders/address/check", {
          params: {
            storeId: this.$store.getters.storeInfo.id,
            streetName: address?.street,
            postCode: address?.postalCode,
            city: address?.city,
            buildingNo: address?.buildingNumber,
            floor: address?.floor,
            schedule_time: this.dateDelivery + " " + this.timeDelivery,
            subTotal: this.$store.getters.cartDetails.subTotal,
            sessionId: this.$store.getters.guestSessionId,
          },
        });
        let addresDatas = data.data;
        if (addresDatas.is_deliverable === false) {
          await this.$store.dispatch(
            "delivery/setDeliveryAddressCheckDetails",
            {
              non_deliverable_reason:
                addresDatas?.non_deliverable_reason ?? undefined,
              non_deliverable_error:
                addresDatas?.non_deliverable_error ?? undefined,
            }
          );
        } else {
          await this.$store.dispatch(
            "delivery/removeDeliveryAddressCheckDetails"
          );
        }
      }

      this.$store.dispatch(
        "delivery/setDropoffDateTime",
        this.dateDelivery + " " + this.timeDelivery
      );

      // Save the confirmed values
      this.savedDateDelivery = this.dateDelivery;
      this.savedTimeDelivery = this.timeDelivery;
      this.valuesChanged = false;

      this.$checkoutValidator.deliveryWhen();
      // this.showWhenOptions = !this.showWhenOptions;
    },

    loadEtimateTime: async function () {
      const self = this;
      self.whenOptions = [];
      self.serviceWhenSelected = "";
      const { data } = await axios.get("/app/orders/estimation/check", {
        params: {
          storeId: self.$store.getters.storeInfo.id,
          orderType: self.$store.getters.deliveryMethod,
        },
      });
      self.etimateTime = data.data;
      self.whenOptions = [...WhenOptions];
      if (!self.etimateTime.asap) {
        self.whenOptions.splice(0, 1);
      }
      self.serviceWhenSelected = self.whenOptions[0];
    },

    loadDatesAvailables: function () {
      const self = this;
      if (self.etimateTime.scheduleFirstDate) {
        self.datesAvilables = self.$appStoreDeliveryTimes.dates(
          self.etimateTime.scheduleFirstDate
        );
        self.dateDelivery = self.datesAvilables[0].value;
      }
    },

    loadTimesAvailables: function () {
      const self = this;
      self.timesAvilables = self.$appStoreDeliveryTimes.timesX(
        self.dateDelivery,
        self.etimateTime.scheduleFirstDate,
        self.etimateTime.scheduleFirstTime
      );
      if (self.timesAvilables.length > 0) {
        // Setting timeDelivery will trigger the watcher which handles
        // dispatch and validation using the current dateDelivery value
        self.timeDelivery = self.timesAvilables[0].value;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.details-bar {
  border-bottom-color: rgb(#aaa, 0.5) !important;
  border-bottom-width: 0.5px !important;
  border-bottom: solid;
  z-index: 2;
}
.details-title-bar {
  font-size: 1.6rem !important;
  font-weight: 700 !important;
}
.details-content {
  padding-top: 70px !important;
}
.details-title {
  font-size: 2.5rem !important;
  font-weight: 800 !important;
}
.btn-text {
  font-size: 1.2rem !important;
  text-transform: none !important;
}
.list-item {
  background-color: white;
  border: solid;
  border-color: rgba(56, 56, 56, 0.2);
  border-width: 0.5px !important;
  border-radius: 5px;
}
.list-header-title {
  font-size: 1.2rem;
  color: black;
  font-weight: 800;
}
.list-text-title {
  font-size: 1.2rem;
  color: #000 !important;
}
.list-text-subtitle {
  font-size: 1rem;
  color: rgba(0, 0, 0, 0.6);
}
.list-text-subtitle.error {
  font-size: 1rem;
  color: white;
  background-color: red;
}
.list-text-change {
  font-size: 0.9rem;
  color: var(--v-primary-base);
  font-weight: 700;
}
.no-deliverable {
  color: white;
  font-size: 1rem;
  font-weight: 700;
}
.list-item-height {
  height: 72px;
}
</style>
